import { type AlipayDialogContext } from '@cart-services/hooks/use-alipay-dialog-flow-actions'
import { useFpAlipayDialogFlowActions } from '@cart-services/hooks/use-fp-alipay-dialog-flow-actions'
import { DialogAlipayHk } from '@cart-ui/DialogAlipayHk/DialogAlipayHk'
import { type CountryCode } from '@constants'
import { type BaseCheckoutPayFlowModule } from '@payments/lib/checkout-pay/BaseCheckoutPayFlowModule'

export interface MerchantAlipayDialogProps {
  context: AlipayDialogContext
  paymentModule: BaseCheckoutPayFlowModule
  countryCode: CountryCode
  onErrorClose: () => void
  onCancelClose?: () => void
}

export const MerchantAlipayDialog = ({ context, paymentModule, countryCode, onErrorClose, onCancelClose }: MerchantAlipayDialogProps) => {
  const { mountAlipayComponent, awaitFlowResult, cancelInFlight } = useFpAlipayDialogFlowActions({ paymentModule, countryCode })
  return (
    <DialogAlipayHk
      context={context}
      onErrorClose={onErrorClose}
      onCancelClose={onCancelClose}
      mountAlipayComponent={mountAlipayComponent}
      awaitFlowResult={awaitFlowResult}
      cancelInFlight={cancelInFlight}
      // buygather 的全域 CSSReset 會清掉 CKO Flow SDK 按鈕自帶的 margin，官網無此問題，這裡補回等值間距。
      actionsGap={4}
    />
  )
}
